import React, { Fragment, memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { Typo, Icon, HR } from 'tmt-ui-kit';
import xss from 'xss';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

// import RectangleItem from './RectangleItem';
import CouponCard from '../../Card/CouponCard';

import Tooltip from '~/components/Tooltip';
import { capitalizeFirstLetter, commaize } from '~/utils/helpers';
import { convert } from '~/utils/price';
import config from '~/config';

const TripVideo = dynamic(
  () => import(/* webpackChunkName: "TripDetail.TripVideo.components" */'./WebV5/TripVideo'),
  { loading: () => null }
);

const TripDetail = styled.div`
  margin-top: 8px;
`;

const DetailRow = styled.div`
  /* display: flex; */
  /* justify-content: space-between; */
  display: grid;
  grid-template-columns: ${props => (props.showCoupon ? '1fr 1fr 1fr' : `repeat(${props.showCount}, 1fr)`)};
  flex: 1;

  ${props => props.showCoupon && `
    flex-wrap: wrap;
    flex-basis: 50%;
    padding-right: 16px;
  `}

  @media(max-width: 600px) {
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 20px;
    justify-content: flex-start;
    padding-right: 0;
    /* overflow-y: scroll; */
    grid-template-columns: 1fr 1fr 1fr;
    ${props => props.showCoupon && `
      flex-basis: unset;
    `}
  }
  @media(max-width: 320px) {
    grid-template-columns: 1fr 1fr;
  }
  @media(min-width: 601px) {
    flex-direction: row;
  }
`;

const IconsContainer = styled.div`
  margin-top: 24px;
  padding-bottom: 0px;
  ${props => props.showCoupon && `
    display: flex;
    justify-content: space-between;
    @media(max-width: 600px) {
      flex-direction: column;
    }
  `}
`;

const DetailContainer = styled.div`
  padding-bottom: 16px;
`;

const DetailList = styled.div`
  ${props => props.first && 'cursor: pointer;'}
  text-align: center;
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  @media(max-width: 600px) {
    padding: 0 8px;
  }
`;

const IconWithPadding = styled(Icon) `
  font-size: 40px;
  color: ${({ isOrange, theme }) => (isOrange ? `${theme.orange}` : `${theme.black}`)};
`;

const DetailDescription = styled(Typo.Paragraph) `
  vertical-align: middle;
  ${props => props.capitalize && 'text-transform: capitalize;'}
  margin: 0px;
  ${props => props.preWrap && 'white-space: pre-wrap;'}
`;

const TripIntroText = styled(DetailDescription)`
  font-size: 15px !important;
`;

const DetailTitle = styled(Typo.Paragraph)`
  font-weight: 600 !important;
  font-size: 15px !important;
  margin: 0;
`;

const FlexDetailTitle = styled(DetailTitle)`
  position: relative;
  /* display: flex; */
  /* align-items: center;
  justify-content: center; */
`;

// const ActivitiesContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap;
// `;

// const ItemContainer = styled.div`
//   width: 16.66%;
//   @media (max-width: 700px) {
//     cursor: pointer;
//     user-select: none;
//     display: inline-block !important;
//     vertical-align: top !important;
//     white-space: normal !important;
//     width: 33.33%;
//   }
//   @media (min-width: 701px) {
//     margin-bottom: 8px;
//   }

//   box-sizing: border-box;
//   @media(max-width: 700px) {
//     &:nth-child(3n-2) {
//       padding-right: 4px;
//     }
//     &:nth-child(3n-1) {
//       padding-left: 4px;
//       padding-right: 4px;
//     }
//     &:nth-child(3n) {
//       padding-left: 4px;
//     }
//   }
//   @media(min-width: 701px) {
//     &:nth-child(6n-5) {
//       padding-right: 4px;
//     }
//     &:not(:nth-child(6n)):not(:nth-child(6n-5)) {
//       padding-left: 4px;
//       padding-right: 4px;
//     }
//     &:nth-child(6n) {
//       padding-left: 4px;
//     }
//   }
// `;

const BoldText = styled(Typo.Paragraph)`
  color: ${props => props.theme.black} !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin: 0 !important;
`;

const Paragraph = styled(Typo.Paragraph)`
  color: ${props => props.theme.black} !important;
  margin: 0 !important;
`;

const BoldSpan = styled.span`
  font-weight: bold;
  font-size: 14px !important;
`;

const PromoText = styled(BoldSpan)`
  color: ${props => props.theme.white} !important;
`;

const HostedByLocalTooltip = styled(Tooltip)`
  display: inline-block;
  height: 24px;
  position: absolute;
  margin-left: -5px;
  .tooltip-popup {
    width: 288px;
    text-align: left;
    left: -100px;
    @media(min-width: 321px) and (max-width: 768px) {
      left: -20vw;
    }
    @media(max-width: 320px) {
      left: -30vw;
    }
  }
  svg {
    left: 0;
  }
  p {
    font-size: 14px;
  }
`;

const mapTransportation = (type) => {
  const transporationObj = {
    text: type
  };
  switch (type) {
    case 'Private Car':
      transporationObj.icon = 'car';
      break;
    case 'Private Motorcycle':
      transporationObj.icon = 'motocycle';
      break;
    case 'Private Van':
      transporationObj.icon = 'van';
      break;
    case 'Private Jetski':
      transporationObj.icon = 'jet-ski';
      break;
    case 'Private Bicycle':
      transporationObj.icon = 'bicycle';
      break;
    case 'Private ATV':
      transporationObj.icon = 'atv';
      break;
    case 'Public Transportation':
      transporationObj.icon = 'bus';
      break;
    default:
      transporationObj.icon = 'car';
      transporationObj.text = 'Private Vehicle';
  }
  return transporationObj;
};

const StaticIntro = memo((props) => {
  const { trip } = props;
  return (
    <Fragment>
      {trip && trip.introduction && (
        <DetailContainer>
          <TripIntroText
            preWrap
            dangerouslySetInnerHTML={{
              __html: xss(trip.introduction),
            }}
          />
        </DetailContainer>
      )}
      {/* <ActivitiesContainer>
        {trip.activities.map(activity => (
          <ItemContainer key={activity}>
            <RectangleItem type={activity} />
          </ItemContainer>
        ))}
      </ActivitiesContainer> */}
      {trip.video_url && <TripVideo url={trip.video_url} name={trip.name} />}
    </Fragment>
  );
}, (prevProps, nextProps) => {
  if (prevProps.trip._id !== nextProps.trip._id) {
    return false;
  }
  return true;
});

const enhance = connect(
  state => ({
    currency: state.session.data.currency,
    rates: state.info.exchangeRates,
  })
);

const TripIntro = props => {
  const { trip, bookingFee, /* lastCouponState, */ currency, rates } = props;
  const showCoupon = false; // (lastCouponState || (bookingFee ? bookingFee > config.firstBooking : false)) && !props.customize;
  const savedPrice = bookingFee ? commaize(convert(bookingFee - config.firstBooking, currency, rates), currency) : '-';
  const duration = trip.duration.split(' ')[0];
  const durationUnit = capitalizeFirstLetter(pluralize('hour', duration));
  // const interestedTravelers = trip.view_count;
  // const interestedTravelersUnit = capitalizeFirstLetter(pluralize('traveler', interestedTravelers));
  // const maxTravelers = trip.max_travelers;
  // const maxTravelersUnit = capitalizeFirstLetter(pluralize('traveler', maxTravelers));
  const transporationObj = mapTransportation(trip.transportation);
  const priceConditions = trip.price_condition.detail_traveler
    ? trip.price_condition.detail_traveler
      .filter(condition => condition.enabled)
      .map(condition => condition.icon)
      .map(c => `${c[0].toUpperCase()}${c.slice(1)}`)
    : [];
  const showCount = trip.search_information && trip.search_information.is_hotel_pickup ? 6 : 5;
  return (
    <TripDetail>
      <IconsContainer showCoupon={showCoupon}>
        <DetailRow showCount={showCount} showCoupon={showCoupon}>
          {/* <DetailList>
            <IconWithPadding name={trip.trip_type === 'private' ? 'user' : 'join-tour'} />
            <DetailDescription capitalize>{trip.trip_type} Tour</DetailDescription>
          </DetailList> */}
          <DetailList first>
            <IconWithPadding isOrange={trip.trip_type === 'private'} name={trip.trip_type === 'private' ? 'lx-user' : 'join-tour'} />
            <FlexDetailTitle>
              {trip.trip_type === 'private'
                ? (
                  <div>
                    <DetailTitle>Hosted by</DetailTitle>
                    <DetailTitle>locals &nbsp;<HostedByLocalTooltip
                      text={<span>A Local Expert is a real local who<br/>connects and shares stories with<br />real insider’s knowledge <a target="_blank" rel="noopener noreferrer" href="/hosted-by-locals">(more)</a></span>}
                    />
                    </DetailTitle>
                    {/* <DetailTitle>
                      Hosted by <br/>locals&nbsp;<HostedByLocalTooltip
                        text={<span>A Local Expert is a real local<br/>who connects and shares stories<br />with real insider’s knowledge<br />in each destination</span>}
                      />
                    </DetailTitle> */}
                  </div>
                ) : 'Group Size'}
              {trip.trip_type === 'joined' && <DetailDescription capitalize>{trip.trip_type} Tour</DetailDescription>}
            </FlexDetailTitle>
          </DetailList>
          <DetailList>
            <IconWithPadding name="clock-24" />
            <DetailTitle>Durations</DetailTitle>
            <DetailDescription>{duration} {durationUnit}</DetailDescription>
          </DetailList>
          <DetailList>
            <IconWithPadding name={transporationObj.icon} />
            <DetailTitle>Vehicle</DetailTitle>
            <DetailDescription>{transporationObj.text}</DetailDescription>
          </DetailList>
          {trip.search_information && trip.search_information.is_hotel_pickup && (
            <DetailList>
              <IconWithPadding name="hotel" />
              <DetailTitle>Free</DetailTitle>
              <DetailDescription>Hotel Pickup</DetailDescription>
            </DetailList>
          )}
          <DetailList>
            <IconWithPadding name="world" />
            <DetailTitle>Hosted In</DetailTitle>
            <DetailDescription>{trip.languages.join(', ')}</DetailDescription>
          </DetailList>
          {priceConditions.length > 0 && (
            <DetailList>
              <IconWithPadding name="booking" />
              <DetailTitle>Includes</DetailTitle>
              <DetailDescription>{priceConditions.join(', ')}</DetailDescription>
            </DetailList>
          )}
          {/* {trip.search_information && !trip.search_information.is_hotel_pickup && <DetailList />} */}
        </DetailRow>
        {(showCoupon) && (
          <CouponCard
            code="FIRSTBOOKING"
            renderText={() => (
              <Fragment>
                <BoldText>First time booking our tour? </BoldText>
                <Paragraph>Apply your &apos;<PromoText>FIRSTBOOKING</PromoText>&apos; promo code and <BoldSpan>save {savedPrice} {currency}!</BoldSpan></Paragraph>
              </Fragment>
            )}
          />
        )}
      </IconsContainer>
      <HR />
      <StaticIntro trip={trip} />
    </TripDetail>
  );
};

TripIntro.propTypes = {
  trip: PropTypes.object,
  bookingFee: PropTypes.number,
  // lastCouponState: PropTypes.bool,
  // customize: PropTypes.bool,
};

export default memo(
  enhance(TripIntro),
  (prevProps, nextProps) => {
    const prevShowCoupon = (prevProps.lastCouponState || (prevProps.bookingFee ? prevProps.bookingFee > config.firstBooking : false)) && !prevProps.customize;
    const nextShowCoupon = (nextProps.lastCouponState || (nextProps.bookingFee ? nextProps.bookingFee > config.firstBooking : false)) && !nextProps.customize;
    if (prevShowCoupon !== nextShowCoupon) {
      return false;
    }
    if (nextShowCoupon && prevProps.bookingFee !== nextProps.bookingFee) {
      return false;
    }
    if (prevProps.currency !== nextProps.currency) {
      return false;
    }
    return true;
  }
);
